import { httpInterceptor } from '../http-interceptor';

export class WaterTowersService {
  static ENDPOINTS = {
    GET_ALL: 'Machine/getAllWaterTowersNew',
    SAVE_NEW: 'Machine/saveNewWaterTower',
    UPDATE: 'Machine/saveNewWaterTower',
    DELETE: 'Machine/deleteWaterTower',
    SAVE_MAINTENANCE: 'Machine/SaveOrUpdateWaterTowersMaintenance',
    UPLOAD_DOCUMENT: 'Customer/Upload',
    GET_MAINTENANCE_RECORDS: 'Machine/getAllMaintenanceRecordsByWaterTowerId',
    GET_MAINTENANCE_RECORD_DETAILS: 'Machine/getWaterTowerMaintenanceRecordDetails',
    ADD_MAINTENANCE_RECORD: 'Machine/saveWaterTowerMaintenanceAllRecords',
    GET_BY_ASSET_NUMBER: 'Machine/getAllWaterTowerByAsstNo',
    GET_SAFETY_CHECKLIST_BY_WATER_TOWER: 'Machine/waterTowerSafetyChecklistByWaterTower',
    SAVE_SAFETY_CHECKLIST: 'Machine/saveOrUpdateWaterTowerSafetyChecklist',
    DELETE_SAFETY_CHECKLIST: 'Machine/deleteWaterTowerSafetyChecklist'
  };

  static async getAllWaterTowers(data) {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL);
  }

  static async saveNewWaterTower(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_NEW, data);
  }

 // Alias for backward compatibility
  static async saveNewWaterTowers(data) {
    return this.saveNewWaterTower(data);
  }

  // Alias for save operations
  static async saveWaterTowers(data) {
    return this.saveNewWaterTower(data);
  }

  static async updateWaterTower(data) {
    return httpInterceptor.post(this.ENDPOINTS.UPDATE, data);
  }

  // Alias for backward compatibility
  static async updateWaterTowers(data) {
    return this.updateWaterTower(data);
  }

  static async deleteWaterTower(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE}/${id}`);
  }

  // Alias for backward compatibility
  static async deleteWaterTowers(id) {
    return this.deleteWaterTower(id);
  }

  static async saveWaterTowersMaintenance(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_MAINTENANCE, data);
  }

  static async uploadDocument(data) {
    return httpInterceptor.postfile(this.ENDPOINTS.UPLOAD_DOCUMENT, data);
  }

  static async getMaintenanceRecordsByWaterTowerId(waterTowerId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORDS}/${waterTowerId}`);
  }

  static async getMaintenanceRecordDetails(recordId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORD_DETAILS}/${recordId}`);
  }

  static async addMaintenanceRecord(data) {
    return httpInterceptor.post(this.ENDPOINTS.ADD_MAINTENANCE_RECORD, data);
  }

  static async getAllWaterTowerByAssetNumber(assetNumber) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ASSET_NUMBER}/${assetNumber}`);
  }

  static async getWaterTowerSafetyChecklistByWaterTower(waterTowerId) {
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_SAFETY_CHECKLIST_BY_WATER_TOWER}/${waterTowerId}`,
    );
  }

  static async createWaterTowerSafetyChecklist(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_SAFETY_CHECKLIST, data);
  }

  static async deleteWaterTowerSafetyChecklist(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE_SAFETY_CHECKLIST}/${id}`);
  }
}
